import { createUseStyles } from 'react-jss';
import { TextColors } from '@picsart/design-system/foundation/textColors';

const useStyles = createUseStyles(
  {
    desktop: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
      color: TextColors.base,
      overflow: 'hidden',
    },
  },
  { name: 'appLayout' }
);

export default useStyles;
